<template>
  <v-container class="white" grid-list-xl fluid ma-0 pa-0><br>
    <v-toolbar flat color="white" height="55">
      <v-flex sm2 pt-6>
        <v-text-field outlined background-color="green lighten-5" dense placeholder="Search" class="caption" prepend-inner-icon="mdi-magnify" v-model="search"></v-text-field>
      </v-flex>
        <v-flex sm1>
        <v-avatar size="25" class="orange elevation-5 mx-1"><v-icon fab small dark @click="clear()">mdi-close</v-icon></v-avatar>
      </v-flex>
        <v-spacer></v-spacer>
      <v-flex sm2>
        <v-avatar size="25" class="blue lighten-1 elevation-2 mx-1" @click.stop="add()"><v-icon right fab class="mx-2" xs-small dark @click.stop="add()">mdi-plus</v-icon></v-avatar>
        <v-avatar size="25" class="blue lighten-1 elevation-2 mx-1"><v-icon fab xs-small dark @click.stop="refresh()">mdi-autorenew</v-icon></v-avatar>
      </v-flex>
    </v-toolbar>

    <v-layout row justify-center>
      <v-dialog v-model="popupbox" max-width="700px" hide-overlay>

        <v-toolbar dark color="indigo lighten-2" height="45">
          <v-toolbar-title class="body-2">Add/Edit Gallery Info</v-toolbar-title>
        </v-toolbar>

        <v-form ref="form" v-model="valid" lazy-validation :close-on-content-click="false" :nudge-right="100" offset-y full-width min-width="500px">
          <v-card class="elevation-1">
            <v-card-text>
               <div class="d-flex">
                <v-select ref="Json.type" outlined background-color="amber lighten-5" :rules="nameRules" dense class="caption mr-1" v-model="Json.type" label="Type" :items="['', 'Photo', 'Video']" placeholder=" " height="25"></v-select>
                </div>
              <div class="d-flex">
                <v-text-field ref="Json.name" background-color="amber lighten-5" outlined dense :rules="nameRules" class="caption mr-1" filled v-model="Json.name" label="Title" placeholder=" " height="25" required></v-text-field>
              </div>
              <div class="d-flex">
                <v-text-field ref="Json.url" background-color="amber lighten-5" outlined dense :rules="nameRules" class="caption mr-1" filled v-model="Json.url" label="Google Photos Url" placeholder=" " height="25" required></v-text-field>
              </div>
              <div class="d-flex">
                <v-text-field ref="Json.photo" background-color="amber lighten-5" outlined dense class="caption mr-1" filled v-model="Json.photo" label="Thumbnail S3 Url (Only for Photos)" placeholder=" " height="25" required></v-text-field>
              </div>
              <div class="d-flex">
                <v-text-field ref="Json.addedTime" background-color="amber lighten-5" outlined dense class="caption mr-1" filled v-model="Json.addedTime" label="added Time" placeholder=" " height="25" disabled></v-text-field>
                <v-text-field ref="Json.updatedTime" background-color="amber lighten-5" outlined dense class="caption mr-1" filled v-model="Json.updatedTime" label="updated Time" placeholder=" " height="25" disabled></v-text-field>
              </div>
              <v-divider></v-divider>
            </v-card-text>
            
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small outline dark color="indigo lighten-2" @click="close">Close</v-btn>
              <v-btn  v-if="Json._id !== ''" small dark outline color="indigo lighten-2" @click="update" :disabled="!valid">Update</v-btn>
              <v-btn  v-if="Json._id === ''" small dark outline color="indigo lighten-2" @click="submit" :disabled="!valid">Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="popup" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Confirmation ?</v-card-title>
          <v-card-text>Are you sure want to delete</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="popup = false">NO</v-btn>
              <v-btn color="primary" text flat @click="confirmdeletion()">Confirm</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-data-table dense :headers="headers" :items-per-page="50" v-bind:items="galleryarray" :search="search" :loading="loading" :sort-by="['addedTime']" :sort-desc="[false]" class="elevation-0">
      <template v-slot:item.Edit-Delete="{ item }">
        <v-avatar size="23" class="blue lighten-1 mx-0 elevation-10"><v-icon small dark  @click=getGalleryById(item._id)>mdi-pencil</v-icon></v-avatar>
        <v-avatar size="23" class="red lighten-1 mx-2 elevation-10"><v-icon small dark  @click=deleteGallery(item._id)>mdi-trash-can</v-icon></v-avatar>
      </template>
    </v-data-table><br><br>
    
  </v-container>
</template>

<script>
import ReportServices from '@/services/ReportServices'

export default {
  data () {
    return {
      search: '',
      loading: false,
      galleryarray: [],
      headers: [
        {text: 'Type', align: 'left', value: 'type' },
        {text: 'Title', align: 'left', value: 'name'},
        {text: 'Thumbnail Photo Url', align: 'left', value: 'photo'},
        {text: 'Photos Url', align: 'left', value: 'url'},
        {text: 'Time', align: 'left', value: 'addedTime'},
        {text: 'Edit-Delete', align: 'left', value: 'Edit-Delete'}
      ],
      Json: {
        _id: '',
        name: '',
        url: '',
        photo: '',
        type: '',
        addedTime:'',
        updatedTime:''
      },
      select: null,
      valid: true,
      name: '',
      nameRules: [v => !!v || 'This Field is required'],
      popupbox: false,
      popup: false
    }
  },
  methods: {
    logoutFromFirebase () {
      this.$store.dispatch('signOutAction')
      .then(() => this.$router.replace('/Signin'))
    },
    clear(){
      this.search = null
    },
    async getGalleryById (id) {
      this.cleardata ()
      if (id) {
        this.popupbox = true
        this.vInfo = (await ReportServices.getGalleryById(id)).data
        this.Json._id = this.vInfo._id
        this.Json.name = this.vInfo.name
        this.Json.url = this.vInfo.url
        this.Json.photo = this.vInfo.photo
        this.Json.type = this.vInfo.type
        this.Json.addedTime = this.vInfo.addedTime
        this.Json.updatedTime = this.vInfo.updatedTime
      }
    },
    cleardata () {
      this.Json._id = ''
      this.Json.name = ''
      this.Json.url = ''
      this.Json.photo = ''
      this.Json.type = ''
      this.Json.addedTime = ''
    },
    async add () {
      this.popupbox = true
      this.cleardata ()
    },
    async submit () {
      if (this.$refs.form.validate()) {
        ReportServices.addGallery(this.Json)
        this.popupbox = false
        setTimeout(() => {
          this.refresh()
        }, 500)
      }
    },
    async update () {
      if (this.$refs.form.validate()) {
        ReportServices.updateGalleryById(this.Json)
        this.popupbox = false
        setTimeout(() => {
          this.refresh()
        }, 200)
      }
    },
    async deleteGallery(id) {
      this.popup = true
      this.id=id
    },
    async confirmdeletion () {
      ReportServices.deleteGalleryById(this.id)
      this.popup = false
      setTimeout(() => {
        this.refresh()
      }, 500)
    },
    async refresh () {
      this.loading = true
      this.galleryarray = (await ReportServices.getAllGalleryInfo()).data
      this.loading = false
      this.noDataText = 'No data available'
    },
    close () {
      this.popupbox = false
      setTimeout(() => {
        this.refresh()
      }, 100)
    }
  },
  async mounted () {
    this.refresh()
  }
}
</script>